import { createPaginatedDto } from '../../../common/dto/paginated-response.factory';
import { ActivityListItemResponseDto } from './activity-list-item.response';

export class PaginatedActivitiesResponseDto extends createPaginatedDto(
  ActivityListItemResponseDto,
) {}
